export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivace elektronické kontroly"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vkladový účet"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivační kód"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šek"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aktivovat"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat elektronický šek"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Částka"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stav"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivní"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušeno"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivace"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vrácení"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Čeká"])}
  }
}